import React, { Fragment } from 'react';

export default function ElementCreation() {
  return (
    <>
      <h1>Element Creation Page</h1>
    </>
  );
}
